import useAssets from '../../../../../common/useAssets';
const cdn = useAssets(false);
const cdnLocal = useAssets(false);
export const buession1 = cdnLocal('images/about/buession-1.png');
export const buession2 = cdnLocal('images/about/buession-2.png');
export const buession3 = cdn('images/about/buession-3.png');
export const arrow = cdn('images/arrow.png');
export const joinUrl = 'https://app.mokahr.com/apply/ruhnn/28238/';
